(function () {
  'use strict';

  var eventName = 'hanso:beehiiv_lead';
  var pendingFormKey = 'hanso_beehiiv_pending_form_lead';
  var recentlyPublished = {};

  function pushEmailLeadToDataLayer(leadSource) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'hanso_email_lead',
      lead_source: leadSource,
    });
  }

  function publishLead(leadType, leadSource, dedupeKey, attempt) {
    var key = dedupeKey || leadType + ':' + leadSource;
    var now = Date.now();
    var currentAttempt = attempt || 0;

    if (recentlyPublished[key] && now - recentlyPublished[key] < 2000) {
      return;
    }

    if (!window.Shopify || !window.Shopify.analytics || typeof window.Shopify.analytics.publish !== 'function') {
      if (currentAttempt < 20) {
        window.setTimeout(function () {
          publishLead(leadType, leadSource, key, currentAttempt + 1);
        }, 250);
      }
      return;
    }

    recentlyPublished[key] = now;

    Promise.resolve(window.Shopify.analytics.publish(eventName, {
      lead_type: leadType,
      lead_source: leadSource,
      page_location: window.location.href,
      page_title: document.title,
    })).catch(function () {});
  }

  function trackContactClicks() {
    document.addEventListener('click', function (event) {
      var link = event.target.closest && event.target.closest('a[href^="tel:"], a[href^="mailto:"]');

      if (!link) {
        return;
      }

      var href = link.getAttribute('href') || '';
      var leadType = href.indexOf('tel:') === 0 ? 'call' : 'message';

      publishLead(leadType, 'storefront_contact_link', leadType + ':' + href);
    });
  }

  function trackContactFormSubmissions() {
    document.addEventListener('submit', function (event) {
      var form = event.target;

      if (!form || !form.matches('form[action*="/contact"], form[action*="contact"]')) {
        return;
      }

      if (typeof form.checkValidity === 'function' && !form.checkValidity()) {
        return;
      }

      window.sessionStorage.setItem(
        pendingFormKey,
        form.id || form.getAttribute('action') || 'contact_form'
      );
    }, true);
  }

  function trackSuccessfulContactForm() {
    var params = new URLSearchParams(window.location.search);
    var pendingForm = window.sessionStorage.getItem(pendingFormKey);
    var hasSuccessMessage = !!document.querySelector('.formStatusMessage--success');

    if ((params.get('contact_posted') !== 'true' && !hasSuccessMessage) || !pendingForm) {
      return;
    }

    window.sessionStorage.removeItem(pendingFormKey);
    publishLead('message', pendingForm, 'contact-form-success:' + pendingForm);

    if (hasSuccessMessage && pendingForm.indexOf('ContactForm-') === 0) {
      pushEmailLeadToDataLayer(pendingForm);
    }
  }

  function init() {
    trackContactClicks();
    trackContactFormSubmissions();
    trackSuccessfulContactForm();
  }

  window.HansoBeehiiv = window.HansoBeehiiv || {};
  window.HansoBeehiiv.trackLead = publishLead;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
